const translations = {
  "en": {
    "24H Performance": "24H Performance"
  },
  "zh-tw": {
    "24H Performance": "24小時表現"
  }
};

export default translations;
